import Notiflix from "notiflix";
import { useContext, useEffect, useState } from "react";
import { FaHome } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { GiSuitcase } from "react-icons/gi";
import { store } from "../../Helper/Context/Store";
import PostApiCall from "../../Helper/PostApi";

export default function UserAddresses(props) {
    const [addressData, setAddressData] = useState([]);
    const { loggedIn, homeLocationModal, setSelectedBillAddress, selectedBillAddress } = useContext(store)
    useEffect(() => {
        getCustomerAddress();
    }, [homeLocationModal])
    const getCustomerAddress = () => {
        var login = localStorage.getItem("CustomerData");
        var logindetails = JSON.parse(login);
        // eslint-disable-next-line eqeqeq
        if (loggedIn === true) {

            PostApiCall.postRequest(
                {
                    whereClause: `where fld_customerid=${logindetails[0].fld_customerid}`,
                },
                "GetCustomerAddress"
            ).then((results) =>
                results.json().then((obj) => {
                    if (results.status === 200 || results.status === 201) {
                        setAddressData(obj.data);
                        Notiflix.Loading.remove();
                    }
                })
            )
        }

    }
    return (
        <>
            {addressData.length > 0 &&
                addressData.slice(0, 3).map((data, index) => (
                    <div className="Col-12" style={{
                        display: addressData == null ? "none" : "block",
                    }}>
                        <div className="boxes">
                            <div className="d-flex">
                                <div className="p-2 bg-light text-center gap-2 pe-3 d-flex align-items-center">
                                    <input
                                        type="radio"
                                        checked={
                                            sessionStorage.getItem(data.fld_address_id) || selectedBillAddress ===
                                                data.fld_address_id
                                                ? true
                                                : false
                                        }
                                        onChange={() => {
                                            setSelectedBillAddress(data.fld_address_id)
                                            sessionStorage.setItem("Selected_Add", data.fld_address_id)

                                            props.handleToggleDetect()
                                            // setSelectedBillingAddress(data);
                                            // setBillingAddress(data.fld_address_id);
                                        }}></input>
                                    <div>
                                        {data.fld_address_type == "Home" ?
                                            <span className="cart-address-icons"><FaHome /></span>
                                            : data.fld_address_type == "Office" ?
                                                <span className="cart-address-icons"><GiSuitcase /></span>
                                                :
                                                <span className="cart-address-icons"><FaLocationDot /></span>
                                        }
                                        <p className="mb-0 fs-6">
                                            {data.fld_address_type}
                                        </p>
                                    </div>
                                </div>
                                <div className="p-2">

                                    <p>
                                        <b>{data.fld_contact_name}</b>
                                    </p>
                                    <p>
                                        {data.fld_contact_number}

                                    </p>
                                    <p>
                                        {data.fld_address_1},{" "}
                                        {data.fld_address_2},{" "}
                                        ,{data.CityName} {data.fld_landmark},
                                        {data.StateName} - {data.fld_pincode}{" "}
                                        ,{data.CountryName} </p>
                                </div>
                            </div>

                        </div>
                    </div>
                ))}

        </>
    )
}